import { Component, EventEmitter, Inject, Input, Optional, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { CommonModule, NgClass, NgIf, TitleCasePipe } from '@angular/common';
import { TextFieldModule } from '@angular/cdk/text-field';
import { FormControl, FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule, MatRippleModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { FuseAlertComponent } from '@fuse/components/alert';
import { ViewUsersComponent } from 'app/users/view-users/view-users.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Util } from 'app/models/util';
import { EventService } from 'app/services/event.service';
import { UserService } from 'app/services/user.service';
import { fuseAnimations } from '@fuse/animations';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { UserImpl } from 'app/models/user';
import { DocumentService } from 'app/services/document.service';
import { Asset, Shared } from 'app/models/document';
import { ToastrService } from 'ngx-toastr';
import { CdkVirtualScrollViewport, ScrollingModule } from '@angular/cdk/scrolling';
import { Subject, Subscription } from 'rxjs';
import { NgxLoadingModule } from "ngx-loading";
import { accessLevel } from 'app/shared/global-constants'
import { MatTooltipModule } from '@angular/material/tooltip';
import { AccessLevel, AssetAccess, } from 'app/models/asset-access';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { TagInputModule } from 'ngx-chips';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { ExternalUser, WebComponentInputParams } from 'app/models/web-component-input-params.model';
import { MatDividerModule } from "@angular/material/divider";
import { LpmLabelPipe } from '@fuse/pipes/lpm-label.pipe';
import { DMS_INSTANCE_ID } from 'app/models/dms-instance.token';

@Component({
  selector: 'app-shared-popoup',
  templateUrl: './shared-popoup.component.html',
  styleUrl: './shared-popoup.component.scss',
  standalone: true,
  animations: fuseAnimations,
  imports: [
    MatButtonModule,
    NgClass,
    MatIconModule,
    ViewUsersComponent,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatOptionModule,
    MatFormFieldModule,
    MatInputModule,
    NgIf,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    TextFieldModule,
    FuseAlertComponent,
    TitleCasePipe,
    CommonModule,
    NgSelectModule,
    MatCheckboxModule,
    ScrollingModule,
    NgxLoadingModule,
    MatTooltipModule,
    MatRippleModule,
    MatTabsModule,
    TagInputModule,
    MatDividerModule,
    LpmLabelPipe
],
  encapsulation: ViewEncapsulation.None,
})
export class SharedPopoupComponent {

  @Output() onModelChange = new EventEmitter()
  @ViewChild('viewport', { static: false }) viewport: CdkVirtualScrollViewport;

  public ngModelValue = null
  public ngModelExt: ExternalUser[] = []
  private searchInterval = null;
  public showSpinner = false;
  public itemsList: any[] = [];
  public itemsListExt: ExternalUser[] = [];
  public contactList: any[] = [];
  public externalUsers: any[] = [];
  public peopleAccess: AssetAccess[] = [];
  public listRole: any[] = [];
  sharedForm: UntypedFormGroup;
  userIds = [];
  user: UserImpl;
  roles = accessLevel;
  isViewer: boolean = null
  selectedTab = 0;
  activeTab: 'internal' | 'external' = 'internal';
  externalUserEmails: any[] = [];
  externalAccess = 'WRITER';
  extNotify: boolean = false;

  // shared : Shared = new Shared();
  level: AssetAccess = new AssetAccess();
  public placeHolder = "Search for users by name or email";

  public isLoading: boolean = false;
  public loadingState: boolean = false;

  public externalLoading: boolean = false;
  isInternalShareSupported: boolean = null;
  isExternalShareSupported: boolean = null;
  WebInputParams: WebComponentInputParams = this.util.getWebComponentInputParams(this.instanceId);
  isWebComponent: boolean = this.util.getIsWebApp();
  predefinedExternalUsers: ExternalUser[] = this.WebInputParams.externalUsers || [];

  // Hide the tab header when at most one sharing tab is visible
  get hideTabHeader(): boolean {
    const internalVisible = this.isInternalShareSupported;
    const externalVisible = this.isWebComponent && this.isExternalShareSupported;
    return !(internalVisible && externalVisible);
  }

  constructor(public matDialogRef: MatDialogRef<SharedPopoupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Asset = null,
    private _formBuilder: UntypedFormBuilder,
    public userService: UserService,
    public util: Util,
    public eventSer: EventService,
    public docServise: DocumentService,
    private toastr: ToastrService,
    private eventServ: EventService,
    private _fuseConfirmationService: FuseConfirmationService,
    @Optional() @Inject(DMS_INSTANCE_ID) private instanceId: string,

  ) { }

  ngOnInit(): void {
    // Pre-populate the external contacts.
    this.predefinedExternalUsers = this.util.getWebComponentInputParams(this.instanceId)?.externalUsers;
    
    if (this.predefinedExternalUsers?.length) {
      this.itemsListExt = this.predefinedExternalUsers;
    }

    // For external search - against angular-elements
    this.isInternalShareSupported = this.WebInputParams.lpmConfig.isInternalShareSupported;
    this.isExternalShareSupported = this.WebInputParams.lpmConfig.isExternalShareSupported;
    this.activeTab = this.isInternalShareSupported ? 'internal' : 'external';
    this.eventSer.callBack.subscribe((list) => {
      this.showSpinner = false;
      if (list?.length) this.itemsListExt = list;
    })

    this.user = this.util.getUserFromSession();
    if (this.data && this.data.id) {
      if (this.data.accessLevel === 'VIEWER') {
        this.level.access = 'VIEWER'
        this.isViewer = true
      }

      this.fetchAccess();
    }
  }

  public onValueChanged(obj: { term: string, items: any[] }) {
    let val = obj.term
    clearTimeout(this.searchInterval);
    this.showSpinner = false;
    if (!this.util.isValidated(val.trim()) || val.length < 3) return;
    this.itemsList = [];
    this.searchInterval = setTimeout(() => {
      this.search(val.trim());

    }, 500);
  }

  // For external - against angular-elements
  public onValueExtChanged(obj: { term: string, items: any[] }) {
    let val = obj.term
    clearTimeout(this.searchInterval);
    this.showSpinner = false;
    if (!this.util.isValidated(val.trim())) {
      this.itemsListExt = this.predefinedExternalUsers;
      return;
    }
    if (val.length < 3) return;

    if (this.WebInputParams?.lpmConfig?.fixedExternalList && this.predefinedExternalUsers?.length) {
      this.filterLocalExternalContacts(val.trim());
      return;
    }

    this.itemsList = [];
    this.searchInterval = setTimeout(() => {
      this.showSpinner = true;
      this.eventSer.searchContacts.emit(val.trim());

    }, 500);
  }

  private filterLocalExternalContacts(term: string) {
    const needle = term.toLowerCase();
    if(!term){
      this.itemsListExt = this.predefinedExternalUsers;
      return;
    }
    this.itemsListExt = (this.predefinedExternalUsers || []).filter((contact) =>
      `${contact.firstName ?? ''} ${contact.lastName ?? ''}`.toLowerCase().includes(needle) ||
      (contact.email ?? '').toLowerCase().includes(needle)
    );
  }

  private search(val) {
    this.showSpinner = true;
    this.userService
      .searchUser(val)
      .then((res) => {
        let userList: [] = this.userService.getData(res);
        if (userList.length > 0) this.itemsList = this.getUsers(userList);

        this.showSpinner = false;
      })
      .catch((err) => {
        this.showSpinner = false;
        console.log(err);
      });
  }

  OnChange(users) {
    this.level.userIds = users;
  }

  add(event) {
    if (!event.userId) {
      this.ngModelExt = this.ngModelExt.filter((list) => list.id != event.id);
      const dialogRef = this._fuseConfirmationService.open(this._formBuilder.group(Util.CBForm).value);
      // Subscribe to afterClosed from the dialog reference
      dialogRef.afterClosed().subscribe((result) => {
        if (result === 'confirmed') {
          console.log('Dismissed');
        }
      });
    }
  }

  fetchAccess() {
    this.isLoading = true;
    this.docServise.getAccess(this.data.id).then((res) => {
      this.peopleAccess = this.docServise.getData(res);
      this.isLoading = false;

    }).catch((error) => {
      this.isLoading = false,
        console.log(error);
    })
  }

  submit() {
    this.loadingState = true;
    this.level.asset.id = this.data.id;
    this.level.url = window.location.href;
    this.docServise.shared(this.level).then((res) => {
      this.toastr.success(
        "This may take time depending on the number of files. You can continue working in the meantime.",
        "Updating sharing permissions"
      );
      this.loadingState = false;
      this.matDialogRef.close();
      this.eventSer.getData.emit('share');
    }).catch((error) => {
      this.loadingState = false;
      console.log(error);
    })
  }

  change(item, index) {
    item.access == 'Remove access' ? this.delete(item.id, index) : this.update(item);
  }

  changeExternal(item, index) {
    item.access == 'Remove access' ? this.delete(item.id, index) : this.updateExtnl(item);
  }

  cancel(): void {
    // Close the dialog
    this.matDialogRef.close();
  }

  getUsers(listUsers) {
    return listUsers.filter(user => !this.peopleAccess.some(access => (user.id === access.user.id)));

  }

  checkExternal() {
    return this.peopleAccess.some(accessLevel => accessLevel.user.userType == 'EXT');
  }

  update(data) {
    this.isLoading = true;
    let level = new AssetAccess();
    level = { ...data, userIds: [] }
    level.userIds.push(level.user.id);
    this.docServise.updateAccess(level).then((res) => {
      this.toastr.success("Update successfully!", "SUCCESS");
      this.isLoading = false;
    }).catch((error) => {
      this.isLoading = false;
      console.log(error);
    })
  }

  updateExtnl(data) {
    let external = {
      externalUsers: [data.user],
      access: data.access,
      assetIds: [this.data.id],
    }

    this.isLoading = true;
    this.docServise.updateExternal(external).then((res) => {
      this.toastr.success("Update successfully!", "SUCCESS");
      this.isLoading = false;
    }).catch((error) => {
      this.isLoading = false;
      console.log(error);
    })
  }

  delete(id, index) {
    this.isLoading = true;
    this.docServise.deleteAccess(id).then((res) => {
      this.peopleAccess.splice(index, 1);
      this.isLoading = false;
      this.toastr.success("Deleted successfully", "SUCCESS");
    }).catch((error) => {
      this.isLoading = false;
      console.log(error);
    })

  }

  private emailValidation(control: FormControl) {
    const pattern = /^[\w]{1,}[\w.+-]{0,}@[\w-]{1,}([.][a-zA-Z]{2,}|[.][\w-]{2,}[.][a-zA-Z]{2,})$/;
    if (!control.value.match(pattern)) {
      return {
        mustBeEmailFormat: true,
      };
    }
    return null;
  }

  public errorMessages = {
    mustBeEmailFormat: "Must be a valid email format",
  };
  public validations = [this.emailValidation];

  submitExShare() {
    this.externalLoading = true;

    let external = {
      externalUsers: this.ngModelExt,
      access: this.externalAccess,
      assetIds: [this.data.id],
      notify: this.extNotify,
      note: this.level.note,
      url: window.location.href,
    }

    this.docServise.sharedExt(external).then((res) => {
      this.toastr.success("Shared successfully", "SUCCESS");
      let data = this.docServise.getData(res);
      this.eventSer.sendResponseToLolly.emit(data);
      this.externalLoading = false;
      this.matDialogRef.close();

    }).catch((error) => {
      this.externalLoading = false;
      console.log(error);
    })
  }

  onTabChanged(event: MatTabChangeEvent) {
    this.selectedTab = event.index;
    this.activeTab = event.tab.textLabel === 'External sharing' ? 'external' : 'internal';
  }

  getEmails() {
    let emails = [];
    this.externalUserEmails.forEach((email, i) => {
      emails.push(email.value)
    })
    return emails;
  }

  isExternal(item) {
    return item.user.userType == 'EXT';
  }

  get ExternalAccessCount() {
    let count = 0;
    if (!this.peopleAccess || this.peopleAccess.length == 0) return 0;
    this.peopleAccess.forEach(access => {
      if (access.user.userType == 'EXT') count++;
    })
    return count;
  }

  get InternalAccessCount() {
    let count = 0;
    if (!this.peopleAccess || this.peopleAccess.length == 0) return 0;
    this.peopleAccess.forEach(access => {
      if (access.user.userType != 'EXT') count++;
    })
    return count;
  }

}
